import { render, staticRenderFns } from "./FrequencyData.vue?vue&type=template&id=2e410915&scoped=true&"
import script from "./FrequencyData.vue?vue&type=script&lang=js&"
export * from "./FrequencyData.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyData.vue?vue&type=style&index=0&id=2e410915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e410915",
  null
  
)

export default component.exports